export default __webpack_public_path__ + "static/media/arrow_up_down.22297d61.svg";